import axios from "axios";
import { API_URL, catchHandler, elseHandler } from "../../helpers/utils";
import { message } from "antd";
import dayjs from "dayjs";

export const AddQuestionAPI =
  (data, onSuccess, onError) => async (dispatch) => {
    try {
      const response = await axios.post(`${API_URL}/quiz-questions-bank`, data);
      if (response.data.success) {
        message.success(response.data.message);
        if (onSuccess) onSuccess();
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      if (onError) onError();
      if (axios.isAxiosError(error) && error.response) {
        const errorMessage =
          error.response.data?.message || "An error occurred";
        message.error(errorMessage);
      } else {
        const errorMessage =
          error instanceof Error ? error.message : "An unknown error occurred";
        message.error(errorMessage);
      }
    }
  };

export const GetQuestionsAPI =
  ({ page, limit, id, search, answerType, questionType, isDeletedView }) =>
  async (dispatch) => {
    try {
      const response = await axios.get(`${API_URL}/quiz-questions-bank`, {
        params: {
          page: page,
          limit: limit,
          search: search,
          id: id,
          ans_type: answerType,
          tag: questionType,
          deleted: isDeletedView,
        },
      });

      let result = response.data;

      if (result?.success) {
        return result;
      } else elseHandler(dispatch, "user", result?.data);
    } catch (e) {
      catchHandler(dispatch, "challenges");
    }
  };

export const GetQuestionTypesAPI = () => async (dispatch) => {
  try {
    const response = await axios.get(
      `${API_URL}/quiz-questions-bank/tags-suggestions`
    );

    let result = response.data;

    if (result?.success) {
      return result;
    } else elseHandler(dispatch, "quiz", result?.data);
  } catch (e) {
    catchHandler(dispatch, "quiz");
  }
};

export const DeleteQuestionAPI =
  (questionId, onSuccess, onError) => async (dispatch) => {
    try {
      const response = await axios.delete(`${API_URL}/quiz-questions-bank`, {
        data: { id: questionId },
      });

      if (response.data.success) {
        message.success(response.data.message);
        if (onSuccess) {
          onSuccess();
        }
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      if (onError) {
        onError();
      }
      if (axios.isAxiosError(error) && error.response) {
        const errorMessage =
          error.response.data?.message || "An error occurred";
        message.error(errorMessage);
      } else {
        const errorMessage =
          error instanceof Error ? error.message : "An unknown error occurred";
        message.error(errorMessage);
      }
    }
  };

export const EditQuestionAPI =
  (data, onSuccess, onError) => async (dispatch) => {
    try {
      const response = await axios.put(`${API_URL}/quiz-questions-bank`, data);

      if (response.data.success) {
        if (onSuccess) {
          onSuccess();
        }
        message.success(response.data.message);
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      if (onError) {
        onError();
      }
      if (axios.isAxiosError(error) && error.response) {
        const errorMessage =
          error.response.data?.message || "An error occurred";
        message.error(errorMessage);
      } else {
        const errorMessage =
          error instanceof Error ? error.message : "An unknown error occurred";
        message.error(errorMessage);
      }
    }
  };

export const UploadCSVFileAPI =
  (file, onUploadProgress) => async (dispatch) => {
    const formData = new FormData();
    formData.append("file", file);

    try {
      const response = await axios.post(
        `${API_URL}/quiz-questions-bank/import`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress,
        }
      );

      return response.data;
    } catch (error) {
      throw error; // handle in component
    }
  };

export const AddQuizAPI = (data, onSuccess, onError) => async (dispatch) => {
  try {
    const response = await axios.post(`${API_URL}/quiz`, data);
    if (response.data.success) {
      message.success(response.data.message);
      if (onSuccess) onSuccess(response.data.data._id);
    } else {
      message.error(response.data.message);
    }
  } catch (error) {
    if (onError) onError();
    if (axios.isAxiosError(error) && error.response) {
      const errorMessage = error.response.data?.message || "An error occurred";
      message.error(errorMessage);
    } else {
      const errorMessage =
        error instanceof Error ? error.message : "An unknown error occurred";
      message.error(errorMessage);
    }
  }
};

export const GetQuizzesAPI =
  ({ page, limit, id, search, deleted }) =>
  async (dispatch) => {
    try {
      const response = await axios.get(`${API_URL}/quiz`, {
        params: {
          page: page,
          limit: limit,
          search: search,
          id: id,
          deleted: deleted,
          localDate: dayjs().format("YYYY-MM-DD"),
        },
      });

      let result = response.data;

      if (result?.success) {
        return result;
      } else elseHandler(dispatch, "user", result?.data);
    } catch (e) {
      catchHandler(dispatch, "challenges");
    }
  };

// export const EditQuizAPI =
//   (data, onSuccess, onError, onDuplicate) => async (dispatch) => {
//     try {
//       const response = await axios.put(`${API_URL}/quiz`, data);

//       if (response.data.success) {
//         if (onSuccess) {
//           onSuccess();
//         }
//         message.success(response.data.message);
//       } else if (response.data.status_code === 409) {
//         if (onDuplicate) {
//           onDuplicate(response.data.data._id);
//         }
//       } else {
//         message.error(response.data.message);
//       }
//     } catch (error) {
//       if (onError) {
//         onError();
//       }
//       if (axios.isAxiosError(error) && error.response) {
//         const errorMessage =
//           error.response.data?.message || "An error occurred";
//         message.error(errorMessage);
//       } else {
//         const errorMessage =
//           error instanceof Error ? error.message : "An unknown error occurred";
//         message.error(errorMessage);
//       }
//     }
//   };

export const EditQuizAPI =
  (data, onSuccess, onError, onDuplicate) => async (dispatch) => {
    try {
      const response = await axios.put(`${API_URL}/quiz`, data);

      if (response.data.success) {
        if (onSuccess) {
          onSuccess();
        }
        message.success(response.data.message);
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      if (axios.isAxiosError(error) && error.response) {
        const { status, data } = error.response;

        // ✅ Handle 409 Conflict here
        if (status === 409) {
          if (onDuplicate) {
            onDuplicate(data?.data?._id); // may need null checks
          }
          return;
        }

        // Other API error
        const errorMessage = data?.message || "An error occurred";
        message.error(errorMessage);
      } else {
        // Non-Axios or unexpected error
        const errorMessage =
          error instanceof Error ? error.message : "An unknown error occurred";
        message.error(errorMessage);
      }

      if (onError) {
        onError();
      }
    }
  };

export const ReorderQuestionAPI =
  (data, onSuccess, onError) => async (dispatch) => {
    try {
      const response = await axios.put(
        `${API_URL}/quiz/reorder-question`,
        data
      );

      if (response.data.success) {
        if (onSuccess) {
          onSuccess();
        }
        // message.success(response.data.message);
      } else {
        // message.error(response.data.message);
      }
    } catch (error) {
      if (onError) {
        onError();
      }
      if (axios.isAxiosError(error) && error.response) {
        const errorMessage =
          error.response.data?.message || "An error occurred";
        message.error(errorMessage);
      } else {
        const errorMessage =
          error instanceof Error ? error.message : "An unknown error occurred";
        message.error(errorMessage);
      }
    }
  };

export const GetQuizParticipantsAPI =
  ({ page, limit, quizId, search }) =>
  async (dispatch) => {
    try {
      const response = await axios.get(`${API_URL}/quiz/attended-users`, {
        params: {
          page: page,
          limit: limit,
          search: search,
          quizId: quizId,
        },
      });

      let result = response.data;

      if (result?.success) {
        return result;
      } else elseHandler(dispatch, "user", result?.data);
    } catch (e) {
      catchHandler(dispatch, "challenges");
    }
  };

export const DeleteQuizAPI =
  (quizId, onSuccess, onError) => async (dispatch) => {
    try {
      const response = await axios.delete(`${API_URL}/quiz`, {
        data: { id: quizId },
      });

      if (response.data.success) {
        message.success(response.data.message);
        if (onSuccess) {
          onSuccess();
        }
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      if (onError) {
        onError();
      }
      if (axios.isAxiosError(error) && error.response) {
        const errorMessage =
          error.response.data?.message || "An error occurred";
        message.error(errorMessage);
      } else {
        const errorMessage =
          error instanceof Error ? error.message : "An unknown error occurred";
        message.error(errorMessage);
      }
    }
  };

export const PublishQuizAPI =
  (data, onSuccess, onError) => async (dispatch) => {
    try {
      const response = await axios.post(`${API_URL}/quiz/publish`, {
        ...data,
        localDate: dayjs().format("YYYY-MM-DD"),
      });
      if (response.data.success) {
        message.success(response.data.message);
        if (onSuccess) onSuccess();
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      if (onError) onError();
      if (axios.isAxiosError(error) && error.response) {
        const errorMessage =
          error.response.data?.message || "An error occurred";
        message.error(errorMessage);
      } else {
        const errorMessage =
          error instanceof Error ? error.message : "An unknown error occurred";
        message.error(errorMessage);
      }
    }
  };

export const ToggleQuizForUser =
  (data, onSuccess, onError) => async (dispatch) => {
    try {
      const response = await axios.put(
        `${API_URL}/auth/quiz-feature-allow`,
        data
      );

      if (response.data.success) {
        if (onSuccess) {
          onSuccess();
        }
        message.success(response.data.message);
      } else {
        message.error(response.data.message);
      }
    } catch (error) {
      if (onError) {
        onError();
      }
      if (axios.isAxiosError(error) && error.response) {
        const errorMessage =
          error.response.data?.message || "An error occurred";
        message.error(errorMessage);
      } else {
        const errorMessage =
          error instanceof Error ? error.message : "An unknown error occurred";
        message.error(errorMessage);
      }
    }
  };
